module.exports = __webpack_public_path__ + "img/744.efe7e964.jpg";